import { ListItemIcon, ListItemText, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomButton from '../button/CustomButton';
import useMode from '../../utils/hooks/useMode';
import { EnumMode } from '../../utils/context/Mode.context';
import { primaryLight } from '../../utils/color';
import { ReactComponent as CroFlag } from '../../assets/icons/flags/cro.svg';
import { ReactComponent as UsaFlag } from '../../assets/icons/flags/usa.svg';

type LanguageSwitcherVariants = 'primary' | 'secondary';

export type LanguageSwitcherProps = {
  variant?: LanguageSwitcherVariants;
};

const LanguageSwitcher = ({ variant = 'primary' }: LanguageSwitcherProps) => {
  const { t, i18n } = useTranslation();
  const { mode } = useMode();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const currentLanguage = i18n.resolvedLanguage;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  const variantStyles = {
    primary: {
      color: '#FFF',
      borderColor: '#FFF',
      backgroundColor: primaryLight[500],
      '&:hover': {
        boxShadow: 'none',
        bgcolor: primaryLight[500],
      },
    },
    secondary: {
      color: primaryLight[500],
      borderColor: primaryLight[500],
      backgroundColor: '#FFF',
      '&:hover': {
        boxShadow: 'none',
        bgcolor: primaryLight[50],
      },
    },
  };

  return (
    <Stack alignItems="center" justifyContent="center">
      <CustomButton
        id="language-button"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="primaryLight"
        onClick={handleClick}
        startIcon={
          currentLanguage === 'en' ? (
            <UsaFlag style={{ height: '17px' }} />
          ) : (
            <CroFlag style={{ height: '17px' }} />
          )
        }
        endIcon={<ExpandMoreIcon />}
        size="small"
        sx={{
          padding: '2px 8px',
          height: '36px',
          minWidth: '6.5rem',
          // color: mode === EnumMode.Supplier ? '#FFF' : primaryLight[500],
          // borderColor: mode === EnumMode.Supplier ? '#FFF' : primaryLight[500],
          // backgroundColor: 'transparent',
          // '&:hover': {
          //   boxShadow: 'none',
          //   bgcolor: mode === EnumMode.Supplier ? primaryLight[500] : primaryLight[50],
          // },
          ...variantStyles[variant],
        }}
      >
        {currentLanguage?.toUpperCase()}
      </CustomButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'language-button',
        }}
      >
        <MenuItem onClick={() => changeLanguage('hr')} selected={currentLanguage === 'hr'}>
          <ListItemIcon
            sx={{
              '&.MuiListItemIcon-root': {
                color: 'rgba(0, 0, 0, 1) !important',
                fontSize: '1.5rem',
              },
            }}
          >
            <CroFlag style={{ height: '17px' }} />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="body3">{t('common.croatian')}</Typography>
          </ListItemText>
        </MenuItem>
        <MenuItem onClick={() => changeLanguage('en')} selected={currentLanguage === 'en'}>
          <ListItemIcon
            sx={{
              '&.MuiListItemIcon-root': {
                color: 'rgba(0, 0, 0, 1) !important',
                fontSize: '1.5rem',
              },
            }}
          >
            <UsaFlag style={{ height: '17px' }} />
          </ListItemIcon>
          <ListItemText>
            {' '}
            <Typography variant="body3">{t('common.english')}</Typography>
          </ListItemText>
        </MenuItem>
      </Menu>
    </Stack>
  );
};

export default LanguageSwitcher;
